import React, { FunctionComponent } from 'react';
import { useTheme } from '@mui/material/styles';
// import { useNavigate } from 'react-router-dom';
// import { useQuery } from "@tanstack/react-query";
// import { useAtom } from 'jotai';
import { useTranslation } from 'react-i18next';
// import useMediaQuery from '@mui/material/useMediaQuery';

// import { fetch_all_with_count, fetch_all } from "../../lib/v31lib";
// import { loginAtom } from '../../../lib/auth';

// import Lenis from "lenis";
// import { ScrollTrigger } from "gsap/ScrollTrigger";
// import { gsap } from "gsap";

import BusinessIcon from '@mui/icons-material/Business';
import CardGiftcardIcon from '@mui/icons-material/CardGiftcard';
import EscalatorWarningIcon from '@mui/icons-material/EscalatorWarning';
import PersonIcon from '@mui/icons-material/Person';
import ShoppingBasketIcon from '@mui/icons-material/ShoppingBasket';

import {
  Box,
  Divider,
  Grid,
} from '@mui/material';
// import {
//   WhiteSection
// } from '../../../components/v2/custom';
import {
  DarkGreenButton,
  LightGreenButton,
  TextButton,
  Typography
} from '../../../components/v2/styled';
import Lenis from 'lenis';

// import { Benefit as Ben } from '../../models/Benefit';
// import { NewsItem as NI } from '../../models/NewsItem';
// import { User, loginFields } from '../../models/User';

// const { DateTime } = require("luxon");

type Props = {
  setStep: (n:number) => void;
  lenis: Lenis;
}

export const EmissionLanding: FunctionComponent<Props> = ({setStep, lenis}) => {
  // const [login, setLogin] = useAtom(loginAtom);
  const theme = useTheme();
  // const navigate = useNavigate();
  const {t, i18n} = useTranslation(['translations']);










  const boxButton = (type: "dark"|"light"|"text", icon: any, label: string, onClick: () => void) => {
    return <Box sx={{
      borderRadius: 1,
      border: '2px solid transparent',
      borderColor: type === "dark" ? theme.palette.primary.main : (type === "light" ? theme.palette.primary.light : 'transparent'),
      padding: 2,
      cursor: 'pointer',
      width: '200px',
      height: '145px',
      display: 'inline-block',
      margin: 1,
      float: 'left',
      "&:hover": {
        borderColor: type === "dark" ? theme.palette.primary.light : (type === "light" ? theme.palette.primary.main : "transparent"),
        "& svg": {
          color: type === "dark" ? theme.palette.primary.light : (type === "light" ? theme.palette.primary.main : theme.palette.primary.light),
        },
        "& hr": {
          backgroundColor: type === "dark" ? theme.palette.primary.light : (type === "light" ? theme.palette.primary.main : theme.palette.primary.light),
        },
        "& p": {
          color: type === "dark" ? theme.palette.primary.light : (type === "light" ? theme.palette.primary.main : theme.palette.primary.light),
        }
      }
    }} onClick={onClick}>
      {icon}
      {/* <PersonIcon sx={{
        color: type === "dark" ? theme.palette.primary.main : theme.palette.primary.light,
      }} /> */}
      <Divider sx={{
        backgroundColor: type === "dark" ? theme.palette.primary.main : (type === "light" ? theme.palette.primary.light : theme.palette.primary.main),
      }} />
      <Box sx={{
        width: '164px',
        height: '52px',
        display: 'table-cell',
        verticalAlign: 'middle',
        textAlign: 'center'
      }}>
        <Typography variant="body1" sx={{
          color: type === "dark" ? theme.palette.primary.main : (type === "light" ? theme.palette.primary.light : theme.palette.primary.main),
          // height: '52px',
          // lineHeight: '52px'
        }}>{label}</Typography>
      </Box>
    </Box>
  }

  
  return <>
    <Grid item xs={12} sx={{textAlign: 'center', paddingTop: 4}}>
      <Typography variant="subtitle1" html fuck_p_tags sx={{
        display: 'inline-block',
        textAlign: 'left',
        // maxWidth: {
        //   xs: '100%',
        //   lg: '440px'
        // }
      }}>{t("nw.emission.landing.fsma_disclaimer")}</Typography>
    </Grid>

    <Grid item xs={12} sx={{textAlign: 'center', paddingTop: 4}}>
      {boxButton("dark", <PersonIcon sx={{
        color:  theme.palette.primary.main,
        height: '50px',
        width: '50px'
      }} />, t("nw.emission.cta.buy_me"), () => {
        setStep(5);
        window.scrollTo(0, 0);
        // @ts-ignore
        if (!!window.dataLayer) window.dataLayer.push({
          event: 'emission',
          eventProps: {
            category: 'landing',
            action: 'buy_for_me',
            label: 'success',
            value: 1
          }
        });
      })}
      {boxButton("dark", <EscalatorWarningIcon sx={{
        color:  theme.palette.primary.main,
        height: '50px',
        width: '50px'
      }} />, t("nw.emission.cta.buy_minor"), () => {
        setStep(15);
        window.scrollTo(0, 0);
        // @ts-ignore
        if (!!window.dataLayer) window.dataLayer.push({
          event: 'emission',
          eventProps: {
            category: 'landing',
            action: 'buy_for_minor',
            label: 'success',
            value: 1
          }
        });
      })}
      {boxButton("dark", <BusinessIcon sx={{
        color:  theme.palette.primary.main,
        height: '50px',
        width: '50px'
      }} />, t("nw.emission.cta.buy_office"), () => {
        setStep(25);
        window.scrollTo(0, 0);
        // @ts-ignore
        if (!!window.dataLayer) window.dataLayer.push({
          event: 'emission',
          eventProps: {
            category: 'landing',
            action: 'buy_for_office',
            label: 'success',
            value: 1
          }
        });
      })}
      {boxButton("dark", <ShoppingBasketIcon sx={{
        color:  theme.palette.primary.main,
        height: '50px',
        width: '50px'
      }} />, t("nw.emission.cta.buy_gift", "Koop cadeaubon"), () => {
        setStep(200);
        setTimeout(() => {
          // lenis.scrollTo("top");
          window.scrollTo(0, 0);
        }, 200);
        // @ts-ignore
        if (!!window.dataLayer) window.dataLayer.push({
          event: 'emission',
          eventProps: {
            category: 'landing',
            action: 'buy_gift',
            label: 'success',
            value: 1
          }
        });
      })}
      {boxButton("dark", <CardGiftcardIcon sx={{
        color:  theme.palette.primary.main,
        height: '50px',
        width: '50px'
      }} />, t("nw.emission.cta.redeem_gift", "Ik heb een cadeaubon"), () => {
        setStep(250);
        window.scrollTo(0, 0);
        // @ts-ignore
        if (!!window.dataLayer) window.dataLayer.push({
          event: 'emission',
          eventProps: {
            category: 'landing',
            action: 'redeem_gift',
            label: 'success',
            value: 1
          }
        });
      })}


      {/* <DarkGreenButton
        label={t("nw.emission.cta.buy_me")}
        id="buy_me"
        onClick={() => {
          setStep(5);
          window.scrollTo(0, 0);
          // @ts-ignore
          if (!!window.dataLayer) window.dataLayer.push({
            event: 'emission',
            eventProps: {
              category: 'landing',
              action: 'buy_for_me',
              label: 'success',
              value: 1
            }
          });
        }}
        sx={{
          marginLeft: 1,
          marginRight: 1,
          marginTop: 1
        }}
      /> */}
      {/* <LightGreenButton
        label={t("nw.emission.cta.buy_minor")}
        id="buy_minor"
        onClick={() => {
          setStep(15);
          window.scrollTo(0, 0);
          // @ts-ignore
          if (!!window.dataLayer) window.dataLayer.push({
            event: 'emission',
            eventProps: {
              category: 'landing',
              action: 'buy_for_minor',
              label: 'success',
              value: 1
            }
          });
        }}
        sx={{
          marginLeft: 1,
          marginRight: 1,
          marginTop: 1
        }}
      /> */}
      {/* <TextButton
        label={t("nw.emission.cta.buy_office")}
        id="buy_office"
        onClick={() => {
          setStep(25);
          window.scrollTo(0, 0);
          // @ts-ignore
          if (!!window.dataLayer) window.dataLayer.push({
            event: 'emission',
            eventProps: {
              category: 'landing',
              action: 'buy_for_office',
              label: 'success',
              value: 1
            }
          });
        }}
        sx={{
          marginLeft: 1,
          marginRight: 1,
          marginTop: 1
        }}
      /> */}
    </Grid>
    <Grid item xs={12} sx={{textAlign: 'center', paddingTop: 4}}>
      <TextButton
        label={t("nw.emission.cta.forgot_url")}
        id="forgot_url"
        onClick={() => {
          setStep(100);
          window.scrollTo(0, 0);
        }}
        sx={{
          marginLeft: 1,
          marginRight: 1,
          marginTop: 1
        }}
      />
    </Grid>
  </>;
}

